export const deviceModel = {

  id: null,
  name: "",
  door_number: "",
  uniqueid: "",
  hashed_imei: null,
  category: "",
  group_id: "",
  contract_id: "",
  type_id: "",
  owner_id: "",
  scaleSensorsSetting: [],

  attributes: [],
  camera_attributes: [],

  weight: 0,

  sequenceNumber: "",
  plateType: "",
  imeiNumber: "",
  referenceKey: "",

  plate_right: "",
  plate_left: "",
  plate_middle: "",
  plate_number: "",
  is_support:false,
  driver_id:"",
  substitute_id:null,

  is_substitute:false,
  assign_to_masader:false,
  wasl:false,
  has_cam:false,
  cap: false,
  madinati: false,
  amana_riyadh: false,
  cam_id: null,
}
